<template lang="html">

  <section class="buttons">
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <h4 class="h2">Instellingen</h4>
            <div style="margin-top: 30px; margin-bottom: 30px;">
              <div>
              </div>
              <div>
                <form action="#" @submit="saveSettings()">
                  <div class="form-group">
                    <label class="label">Aantal consecutieve gesprekken</label>
                    <div class="input-group">
                      <input type="text" class="form-control" v-model="consecutiveCalls" ref="consecutiveCalls" placeholder="Voornaam" id="consecutiveCalls">
                    </div>
                  </div>
                  <b-button class="btn btn-success" @click="saveSettings()">Opslaan</b-button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

</template>

<script lang="js">
import Modal from '../modals/Modal'
import axios from 'axios'
import store from '../../store'
let server = require('../../server')
export default {
  name: 'buttons',
  components: {
    Modal
  },
  data () {
    return {
      users_db: [],
      consecutiveCalls: 0
    }
  },
  computed: {
    role () {
      return store.state.role
    },
    user () {
      return store.state.user
    },
    office () {
      return store.state.office
    },
    officeString () {
      return store.state.officeString
    }
  },
  async created () {
    let self = this
    try {
      await axios({
        method: 'get',
        url: server.SERVER_URL + '/get_consecutive_calls_by_office_id/' + this.office.toString()
      })
        .then(function (response) {
          console.log('consecutive calls data = ')
          console.log(response.data)
          self.consecutiveCalls = response.data
        })
    } catch (e) {
      console.log('Error while trying to get users!')
      console.log(e)
    }
  },
  methods: {
    async getOfficeSetting () {
    },
    async saveSettings () {
      try {
        let postData = {
          consecutiveCalls: this.consecutiveCalls,
          officeId: this.office
        }
        await axios({
          method: 'post',
          url: server.SERVER_URL + '/update_office_settings',
          data: postData
        })
      } catch (e) {
        console.log('Error while trying to update office settings!')
        console.log(e)
      }
    }
  }
}
</script>

<style scoped lang="scss">
// utilities
.overflow-hidden {
  overflow: hidden;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.d-flex {
  display: flex;
}
.align-items-center {
  align-items: center;
}
.justify-content-between {
  justify-content: space-between;
}
// reset
button {
  outline: inherit;
  cursor: pointer;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/basic-elements/settings.vue